import type { FC, PropsWithChildren } from 'react';

import { useMedia } from '@opendoor/bricks-next';
import { AddContextualData } from '@opendoor/observability';

function getDeviceSize(
  smallerThanMD: boolean,
  smallerThanLG: boolean,
): 'desktop' | 'tablet' | 'mobile' {
  if (smallerThanMD) {
    return 'mobile';
  }
  if (smallerThanLG) {
    return 'tablet';
  }
  return 'desktop';
}

/**
 * Attaches the current device size category to observability contextual data
 * so it is included as an attribute on analytics events.
 */
export const DeviceSizeContextualData: FC<PropsWithChildren> = ({ children }) => {
  const { smallerThanMD, smallerThanLG } = useMedia();
  return (
    <AddContextualData data={{ deviceSize: getDeviceSize(smallerThanMD, smallerThanLG) }}>
      {children}
    </AddContextualData>
  );
};
